import React from 'react';
import './index.scss';

class MarketingPanel extends React.Component {
  render() {
    return (
      <div class="marketing__page">
        <div class="marketing__header">
          <h1 class="marketing__page__title">
            Market your venue{' '}
            <span class="marketing__page__subtitle">with</span>{' '}
            <img
              class="marketing__page__logo"
              alt="Fatsoma logo"
              src={process.env.PUBLIC_URL + '/img/marketing/fatsoma-logo.svg'}
            />
          </h1>
        </div>

        <div class="marketing__wrapper">
          <div class="marketing__container">
            <div class="marketing__container__left">
              <p class="marketing__tease__title">
                We’re connecting Tabb and Fatsoma together so we can unlock our
                full range of social marketing tools for your venue. We’ll email
                you the moment this launches.
              </p>
              <p class="marketing__tease__description">
                Plus, we’ll automatically add all of your Tabb customers (who
                haven’t opted-out of marketing) to your Fatsoma following. So
                no-one misses out.
              </p>
            </div>

            <div class="marketing__container__right">
              <div class="marketing__btn">Coming 2022</div>
            </div>
          </div>
        </div>

        <div class="marketing__cards">
          <div class="marketing__card">
            <div class="marketing__card__header">
              <h2 class="marketing__card__title">Events</h2>
              <p class="marketing__card__description">
                Put on and sell out events with confidence. And reduce your
                marketing costs by promoting directly to the followers you’ve
                gained through Tabb.
              </p>
            </div>

            <div class="marketing__card__image">
              <img
                class="marketing__card__img"
                alt="Events"
                src={process.env.PUBLIC_URL + '/img/marketing/events.png'}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default MarketingPanel;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/Marketing/index.jsx